module.exports = __webpack_public_path__ + "static/kran02_3840-b8c7b1348dff41f6fdacd8688580f19f.jpg";